import {Card, Row} from 'antd';
import {DollarTwoTone} from "@ant-design/icons";
import {useNavigate} from "react-router";

export const ReportMenu = ({refresh, onRefresh, onApiFail}) => {
    const navigate = useNavigate();

    const onProfitClick = () => {
        navigate('/report/profit');
    }

    const onCogsClick = () => {
        navigate('/report/cogs');
    }

    const onBatchClick = () => {
        navigate('/report/batch');
    }

    const onPurchaseOrderClick = () => {
        navigate('/report/purchaseorder');
    }

    const onCashFlowClick = () => {
        navigate('/report/cashflow');
    }

    const profitTitle = <div>
        <div><DollarTwoTone />  Profit Report</div>
    </div>

    return <div style={{backgroundColor: "#8f8f8f"}}>
    <Row>
        <Card size="small" title={profitTitle} variant={"borderless"} style={{margin: 16, width: 300, cursor: 'pointer'}} onClick={onProfitClick}>
            <ul style={{textAlign: 'left'}}>
                <li>Compile a report on Invoices</li>
                <li>Display Profit, and Margin</li>
                <li>Selectable Date Range</li>
            </ul>
        </Card>
        <Card size="small" title="COGS Report" variant={"borderless"} style={{margin: 16, width: 300, cursor: 'pointer'}} onClick={onCogsClick}>
            <ul style={{textAlign: 'left'}}>
                <li>Compile a report on Cost of Goods (COGS)</li>
                <li>Aggregates cost for Packaged Products</li>
            </ul>
        </Card>
        <Card size="small" title="Batch Report" variant={"borderless"} style={{margin: 16, width: 300, cursor: 'pointer'}} onClick={onBatchClick}>
            <ul style={{textAlign: 'left'}}>
                <li>Compile a report for a Batch</li>
                <li>List all products sold for a Batch</li>
            </ul>
        </Card>
        <Card size="small" title="Purchase Order Report" variant={"borderless"} style={{margin: 16, width: 300, cursor: 'pointer'}} onClick={onPurchaseOrderClick}>
            <ul style={{textAlign: 'left'}}>
                <li>Compile a report for Purchase Orders</li>
                <li>List time/cost breakdown for Purchase Orders</li>
            </ul>
        </Card>
        <Card size="small" title="Cash Flow Report" variant={"borderless"} style={{margin: 16, width: 300, cursor: 'pointer'}} onClick={onCashFlowClick}>
            <ul style={{textAlign: 'left'}}>
                <li>Compile a report for Cash Flow</li>
                <li>List bank transactions for a period of time</li>
            </ul>
        </Card>
        <Card size="small" title="Fourth Report" variant={"borderless"} style={{margin: 16, width: 300}}>
            <ul style={{textAlign: 'left'}}>
                <li>Future implementation</li>
            </ul>
        </Card>
    </Row>

    </div>
}